module.exports = __webpack_public_path__ + "static/media/addUser.eb57e153.svg";